import {createStore} from "vuex";
import {packages} from "./modules/packages";
import {categories} from "./modules/categories";
import {apiKey} from "./modules/apiKey";

const store = createStore({
    modules: {packages, categories, apiKey}
})

export default store